import React, { useEffect, useState } from "react";
import { StakeUnstake } from "./style";
import Button from "../styled/Button/Button";
import PropTypes from "prop-types";

function TwoButton({
  buttons,
  space = false,
  current: _current,
  colorShift = true,
}) {
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    setCurrent(_current);
  }, [_current]);

  const clickHandler = (id, onClick) => {
    colorShift && setCurrent(id);
    onClick && onClick(id);
  };

  return (
    <StakeUnstake space={space}>
      {buttons?.map(({ name, onClick, identifier, modal, ...rest }) => {
        return (
          <Button
            onClick={() => clickHandler(identifier, onClick)}
            color={current && current === identifier ? "primary" : "secondary"}
            modal
            {...rest}
          >
            {name}
          </Button>
        );
      })}
    </StakeUnstake>
  );
}

export default TwoButton;

TwoButton.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      ...Button.propTypes,
      identifier: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  current: PropTypes.string,
  space: PropTypes.bool,
  colorShift: PropTypes.bool,
};
